
"use strict";

var React = require('react');
var Link = require('react-router').Link;
var classNames = require('classnames');

class ProgramCategoryNavigation extends React.Component {
	render() {

		var { categories, ...other} = this.props;


		if(!categories || categories.isEmpty()) {
			return false;
		}

		return (
			<ul {...other} className="svtse_program-list-categories__list">
				{categories.toArray().map( function(item, index){
					
					var query = this.context.location.query? Object.assign({}, this.context.location.query) : {};
					query.kategori = item.get('toggleQuery', undefined);
					if(!query.kategori) {
						delete query.kategori;
					}

					var linkClass = classNames(
						'svtse_program-list-categories__link',
						item.get('isActive', false) ? 'svtse_program-list-categories__link--active' : false,
						item.get('isActive', false) ? 'svtse_program-list-categories__link--' + item.get('id', index) : false
					);

					return (
						<li  className="svtse_program-list-categories__item" key={item.get('id', index)}>
							<Link to="/program/" className={linkClass} query={query}>{item.get('title')}</Link>
						</li>
					);
				}.bind(this))}
			</ul>
		);
	}
}

ProgramCategoryNavigation.contextTypes = {
		location: React.PropTypes.object.isRequired
};

module.exports = ProgramCategoryNavigation;



/** WEBPACK FOOTER **
 ** ./app/components/ProgramListHandler/ProgramCategoryNavigation.jsx
 **/